import { Directive, ElementRef, HostListener, Optional } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appNoLeadingSpace]'
})
export class NoLeadingSpaceDirective {
  constructor(private readonly el: ElementRef<HTMLInputElement | HTMLTextAreaElement>,
              @Optional() private readonly control: NgControl) {}

  @HostListener('keydown', ['$event'])
  onKeydown(event: KeyboardEvent): void {
    if (event.key !== ' ' && event.code !== 'Space') {
      return;
    }
    const input = this.el.nativeElement as HTMLInputElement;
    const start = input.selectionStart ?? 0;
    const value = input.value ?? '';
    if (start === 0 || !value.slice(0, start).trim()) {
      event.preventDefault();
    }
  }

  @HostListener('input', ['$event'])
  onInput(): void {
    const input = this.el.nativeElement as HTMLInputElement;
    const original = input.value ?? '';
    if (!original.startsWith(' ') && !original.startsWith('\t')) {
      return;
    }
    const cleaned = original.replace(/^\s+/, '');
    input.value = cleaned;
    if (this.control?.control) {
      this.control.control.setValue(cleaned, { emitEvent: true });
    }
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent): void {
    const input = this.el.nativeElement as HTMLInputElement;
    if ((input.selectionStart ?? 0) !== 0) {
      return;
    }
    const pasted = event.clipboardData?.getData('text') ?? '';
    if (!/^\s/.test(pasted)) {
      return;
    }
    event.preventDefault();
    const cleaned = pasted.replace(/^\s+/, '') + (input.value ?? '').slice(input.selectionEnd ?? 0);
    input.value = cleaned;
    if (this.control?.control) {
      this.control.control.setValue(cleaned, { emitEvent: true });
    }
  }
}
